var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgH1VideoScreening(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.18 22H60.5a15.21 15.21 0 00-10.73-4h-.09c-4.51 0-7.92 1.23-10.82 4h-27A3.87 3.87 0 008 25.81v23.37A3.87 3.87 0 0011.81 53h8.25a3 3 0 006 0h29.45a3 3 0 006 0h2.68A3.87 3.87 0 0068 49.18V25.81A3.87 3.87 0 0064.18 22zM64 49H12V26h28.56c2.4-2.83 5.07-4 9-4h.22a11.44 11.44 0 019 4H64v23zM49.68 27.52a9.5 9.5 0 109.5 9.5 9.51 9.51 0 00-9.5-9.5zm0 15a5.5 5.5 0 110-11 5.5 5.5 0 010 11zm-12.37-9.27a3 3 0 11-5.999 0 3 3 0 015.999 0zM16 40h15v4H16v-4zm10-3H16v-4h10v4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/H1_Video_screening.671b76aa.svg";
export { SvgH1VideoScreening as ReactComponent };